import axios from 'axios'
import {
  baseUrl
} from "./url.js";
import router from "../router";
import { clearAuthToken, getAuthToken, TOKEN_NAME } from "../utils/auth";
import {
  Message
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


// axios 0.20 默认 paramsSerializer 会把 %5B/%5D 反解码回 [ ] (为了兼容 PHP key[]=v 数组写法)。
// Tomcat 11 严格模式按 RFC 3986 拒收裸 [ ],会在请求行解析阶段就 400 IllegalArgumentException。
// 全局改用严格 encodeURIComponent,对每个 value 都完整 encode,不做例外。
const strictParamsSerializer = params => {
  if (!params) return "";
  const parts = [];
  Object.keys(params).forEach(key => {
    const val = params[key];
    if (val === null || val === undefined) return;
    const values = Array.isArray(val) ? val : [val];
    values.forEach(v => {
      const s = v instanceof Date ? v.toISOString() : (typeof v === "object" ? JSON.stringify(v) : v);
      parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(s));
    });
  });
  return parts.join("&");
};

// 根据环境切换接口地址
const ajaxInstance = axios.create({
  baseURL: baseUrl(),
  paramsSerializer: strictParamsSerializer,
  // timeout: 10000
});
const bigdataRequest = axios.create({
  baseURL: baseUrl(),
  paramsSerializer: strictParamsSerializer,
  // timeout: 10000
});

const attachGatewayToken = config => {
  const token = getAuthToken();
  if (token) {
    config.headers = Object.assign({}, config.headers, { [TOKEN_NAME]: token });
  }
  return config;
};

// 添加请求拦截器
ajaxInstance.interceptors.request.use(
  config => {
    // debugger
    if (!config.data && !(config.data instanceof FormData)) {
      config.data = {};
    }
    const hasExplicitContentType = Object.keys(config.headers || {})
      .some(name => name.toLowerCase() === "content-type");
    if (config.method == "post" && !(config.data instanceof FormData)
        && config.url !== "/auth/login" && !hasExplicitContentType) {
      config.headers = Object.assign({}, config.headers, {
        'Content-Type': 'application/x-www-form-urlencoded'
      });
    }
    // config.withCredentials = true;
    // config.headers = {
    //   // "Content-Type": "application/x-www-form-urlencoded",
    //   "Access-Control-Allow-Origin": "http://localhost:8888/",
    //   "Access-Control-Allow-Headers": "Authorization,content-type",
    // };
    return attachGatewayToken(config);
  },
  error => Promise.reject(error)
);

// 大数据调用保留 AxiosResponse 结构，但同样必须携带网关令牌。
bigdataRequest.interceptors.request.use(attachGatewayToken, error => Promise.reject(error));

const handleHttpError = error => {
  const response = error.response;
  const data = response && response.data;
  const status = response && response.status;
  const backendMsg = (data && (data.message || data.msg)) || "";

  if (status === 401 || (data && data.code === 401)) {
    clearAuthToken();
    if (router.currentRoute.path !== "/client/loginTest") {
      router.replace({ path: "/client/loginTest", query: { redirect: router.currentRoute.fullPath } });
    }
  } else if (status === 403) {
    // gateway PermissionGatewayFilter 拒绝时会返回 {"code":403,"message":"无权限访问该接口: xxx"}
    Message.error(backendMsg || "无权限访问该接口");
  } else if (status) {
    // 其它 HTTP 错误(404/500/…)也给一个统一提示,避免用户点了没反应。
    Message.error(backendMsg || `请求失败 (${status})`);
  } else {
    // 断网 / 跨域 / 请求被取消:error.message 一般是 "Network Error" 之类。
    Message.error(error.message || "网络异常,请稍后重试");
  }
  return Promise.reject(data || error);
};

// 添加响应拦截器
ajaxInstance.interceptors.response.use(
  res => {
    const {
      request: {
        responseURL
      },
      data: {
        result: result,
        message: message,
        code: code
      } = {}
    } = res;
    if (result === 1 || code === 0) {
      res.data.params = res.config.params || {};
      return res.data;
    }
    // if(responseURL.indexOf('login') > 0){
    //   console.log('未登录');
    //   router.push('login');
    //   return Promise.reject().catch(() => {return {}});
    // }
    // if(!['', undefined, null].includes(message)){
    //   Message({
    //     type: 'error',
    //     message: message
    //   });
    // }
    return Promise.reject(res.data);
  },
  handleHttpError
);
bigdataRequest.interceptors.response.use(response => response, handleHttpError);
export {
  bigdataRequest
};
export default ajaxInstance;
